import axios, { AxiosRequestConfig } from "axios";
import { ENVIRONMENT } from "../../../../environment/environment";
import requestInterceptor from "../interceptors/request.interceptor";
import { error } from "console";
import { errorInterceptor } from "../interceptors/erros.interceptor";

const instance = axios.create({
    timeout: 25000,
    baseURL: ENVIRONMENT.BASE_URL_API,
});

instance.interceptors.request.use(
    (requestInterceptor),
    (error) => errorInterceptor(error)
);

/* Store requests */
const sourceRequest: Record<string, any> = {};

const controller = new AbortController();
const timeoutInterceptor = instance.interceptors.request.use(
    async (request: any) => {
        /* If the application exists cancel */
        if (sourceRequest[request.url]) {
            request.signal = controller.signal;
        }

        return request;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Set a timeout to cancel the request
setTimeout(() => {
    instance.interceptors.request.eject(timeoutInterceptor);
    controller.abort();
}, 5000);

export const baseApiService = {
    request(config = {}) {
        return instance.request(config);
    },
    get(url: string, config?: AxiosRequestConfig<any> | undefined) {
        return instance.get(url, config);
    },
    post(url: string, data?: any, config?: AxiosRequestConfig<any> | undefined) {
        return instance.post(url, data, config);
    },
    put(url: string, data?: any, config?: AxiosRequestConfig<any> | undefined) {
        return instance.put(url, data, config);
    },
    patch(url: string, data?: any) {
        return instance.patch(url, data);
    },
    delete(url: string, config?: AxiosRequestConfig<any> | undefined) {
        return instance.delete(url, config);
    },
};
